import { heroPhoneImage, heroPosterImage } from "@/mocks/banana";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-background-100"
    >
      {/* 装饰背景元素 */}
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-200/60 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 top-40 h-64 w-64 rounded-full bg-accent-200/60 blur-3xl" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-4 pb-16 pt-28 md:px-6 md:pt-32 lg:grid-cols-2 lg:pb-24">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-800">
            <i className="ri-flashlight-line" />
            全网漫画，一键畅读
          </span>
          <h1 className="mt-5 font-heading text-3xl leading-tight text-foreground-950 md:text-5xl">
            香蕉漫画
            <span className="block text-accent-600">
              离线阅读 · 缓存 · 订阅收藏
            </span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            香蕉漫画APP下载，支持电脑版与手机版。高清漫画随行，离线也能畅快追更，
            缓存、订阅、收藏一应俱全，随时随地想看就看。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#download"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-base font-medium text-background-50 transition-transform hover:-translate-y-0.5 hover:bg-primary-600"
            >
              <i className="ri-download-2-line text-xl" />
              立即下载APP
            </a>
            <a
              href="#features"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-base font-medium text-foreground-900 transition-colors hover:bg-background-200"
            >
              了解更多功能
            </a>
          </div>

          <dl className="mt-10 grid max-w-md grid-cols-3 gap-4">
            {[
              { k: "5万+", v: "海量漫画" },
              { k: "5000万", v: "累计阅读" },
              { k: "4.9分", v: "用户评分" },
            ].map((s) => (
              <div
                key={s.k}
                className="rounded-2xl border border-background-200 bg-background-50/70 px-4 py-3 text-center"
              >
                <dt className="text-sm text-foreground-600">{s.v}</dt>
                <dd className="font-heading text-2xl text-accent-600">{s.k}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 手机 + 海报 */}
        <div className="relative mx-auto w-full max-w-sm lg:max-w-md">
          <div className="relative mx-auto w-56 overflow-hidden rounded-[2.2rem] border-8 border-foreground-950 shadow-xl md:w-60">
            <img
              src={heroPhoneImage}
              alt="香蕉漫画APP手机版漫画阅读界面，支持离线阅读与高清缓存"
              title="香蕉漫画手机版 离线阅读界面"
              className="h-[480px] w-full object-cover md:h-[520px]"
            />
            <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/40 to-transparent px-4 pb-4 pt-12 text-center text-sm font-medium text-white">
              离线缓存 · 随时随地畅读
            </span>
          </div>
          <img
            src={heroPosterImage}
            alt="香蕉漫画热血冒险漫画海报，漫画人物在空中翱翔"
            title="香蕉漫画 热血冒险漫画海报"
            className="absolute -right-6 bottom-6 hidden w-32 rotate-6 rounded-2xl border-4 border-background-50 object-cover shadow-lg md:block lg:w-36"
          />
          <span className="absolute -left-4 top-6 inline-flex items-center gap-1 rounded-full bg-secondary-500 px-3 py-1.5 text-xs font-medium text-background-50">
            <i className="ri-wifi-off-line" />
            离线也能看
          </span>
        </div>
      </div>
    </section>
  );
}